import { gql } from '@apollo/client';

export default gql`
  mutation createInvoiceLink($id: String) {
    createInvoiceLink(id: $id) {
      ok
      message
      data
      error
    }
  }
`;
